export const DriverType = {
    driver: "driver",
    EVUser: "evUser",
}

export const DriverTypeEnum = {
    EVUser: 1,
    driver: 2,
}